<template>
  <div>
    <el-card>
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.licensePlateNumber')">
              <el-input
                v-model="listVal"
                type="textarea"
                :placeholder="$t('mdfeTranslate.each10PlatesNumber')"
                :rows="5"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('mdfeTranslate.MDFEKey')">
              <el-input
                v-model="mdfeKey"
                type="textarea"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="5"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-col :span="14">
                <!-- 开票时间 -->
                <el-form-item :label="$t('GlobalSetObj.CreationTime')">
                  <el-date-picker
                    v-model="queryForm.params.invoiceIssueTime"
                    type="datetimerange"
                    range-separator="-"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions"
                    :default-time="['00:00:00', '23:59:59']"
                    :start-placeholder="$t('GlobalSetObj.startDate')"
                    :end-placeholder="$t('GlobalSetObj.endDate')"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 状态 -->
                <el-form-item :label="$t('collectionCenter.stateZT')">
                  <el-select
                    v-model="queryForm.params.status"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    style="width: 100%;"
                  >
                    <!--全部-->
                    <el-option :key="0" :label="$t('collectionCenter.tudo')" :value="null" />
                    <!--成功-->
                    <el-option :key="1" :label="$t('operationCenter.succeed')" :value="1" />
                    <!--失败-->
                    <el-option :key="2" :label="$t('operationCenter.fail')" :value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <!-- 操作类型 -->
                <el-form-item :label="$t('collectionCenter.operationType')">
                  <el-select
                    v-model="queryForm.params.operationType"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    style="width: 100%;"
                  >
                    <!--全部-->
                    <el-option :key="0" :label="$t('collectionCenter.tudo')" :value="null" />
                    <!--已授权-->
                    <el-option :key="1" :label="$t('mdfeTranslate.Authorized')" :value="1" />
                    <!--已取消-->
                    <el-option :key="2" :label="$t('GlobalSetObj.Canceled')" :value="2" />
                    <!--已关闭-->
                    <el-option :key="3" :label="$t('mdfeTranslate.Closed')" :value="3" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div style="margin-top: 28px;">
                  <!--查询-->
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    @click="getTable"
                  >{{ $t('basicData.Search') }}
                  </el-button>
                  <!--重置-->
                  <el-button
                    icon="el-icon-refresh"
                    size="mini"
                    @click="onReset"
                  >{{ $t('basicData.reset') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        border
        class="table-height"
        :header-cell-style="{background:'#f2f2f2',color:'black'}"
        :height="tableHeightRow.height"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="80"
          fixed="left"
        />
        <!-- 操作类型 -->
        <el-table-column
          prop="operationType"
          :label="$t('collectionCenter.operationType')"
          min-width="160"
          align="center"
        >
          <template v-slot="scope">
            <!--'已授权'-->
            <el-tag v-if="scope.row.operationType === 1" type="success">{{ $t('mdfeTranslate.Authorized') }}</el-tag>
            <!--已取消-->
            <el-tag v-else-if="scope.row.operationType === 2" type="info">{{ $t('GlobalSetObj.Canceled') }}</el-tag>
            <!--已关闭-->
            <el-tag v-else-if="scope.row.operationType === 3" type="danger">{{ $t('mdfeTranslate.Closed') }}</el-tag>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          prop="status"
          :label="$t('GlobalSetObj.status')"
          min-width="120"
          align="center"
        >
          <template v-slot="scope">
            <!--成功-->
            <el-tag v-if="scope.row.status === 1" type="success">{{ $t('GlobalSetObj.succeed') }}</el-tag>
            <!--失败-->
            <el-tag v-else-if="scope.row.status === 2" type="danger">{{ $t('GlobalSetObj.Lose') }}</el-tag>
          </template>
        </el-table-column>
        <!-- 车牌号 -->
        <el-table-column
          prop="vehiclePlate"
          :label="$t('seller.licensePlateNumber')"
          min-width="120"
          align="center"
        >
          <template v-slot="scope">
            <div v-if="scope.row.transportInfo">
              <div v-for="(item, index) in scope.row.transportInfo.vehiclePlate" :key="index">{{ item }}</div>
            </div>
          </template>
        </el-table-column>
        <!-- 原始请求参数 -->
        <el-table-column
          prop="originRequestParam"
          :label="$t('mdfeTranslate.originalRequestParams')"
          min-width="200"
          :show-overflow-tooltip="false"
        >
          <template v-slot="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                {{ scope.row.originRequestParam }}
              </pre>
              <div class="paramsStyle">{{ scope.row.originRequestParam }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 响应数据 -->
        <el-table-column
          prop="responseData"
          :label="$t('mdfeTranslate.responseData')"
          min-width="200"
          :show-overflow-tooltip="false"
        >
          <template v-slot="scope">
            <el-tooltip placement="top">
              <pre slot="content" style="max-height: 400px; overflow: auto">
                {{ scope.row.responseData }}
              </pre>
              <div class="paramsStyle">{{ scope.row.responseData }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 操作人 -->
        <el-table-column prop="createUserStr" :label="$t('GlobalSetObj.operator')" min-width="180" />
        <!-- 操作时间 -->
        <el-table-column prop="updateTime" :label="$t('GlobalSetObj.operationTime')" min-width="180" />
        <!-- 备注 -->
        <el-table-column prop="remark" :label="$t('collectionCenter.Note')" min-width="180" />
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getCurrentTable"
          @size-change="getSizeTable"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { getMdfeOperationLog } from '@/api/invoiceCenter';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import dayjs from 'dayjs';
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'MdfeLog',
  mixins: [estimateTableHeight],
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          invoiceIssueTime: [startTime, endTime],
          status: null,
          operationType: null
        }
      },
      total: 0,
      tableData: [],
      pickerMinDate: '',
      pickerRange: 6 * 24 * 60 * 60 * 1000, // 可选择日期范围 为7天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      listVal: '',
      mdfeKey: ''
    };
  },
  created() {
    this.userObj = getUserIdAndNameObj();
    this.getTable();
  },
  methods: {
    // 获取列表
    getTable() {
      const { invoiceIssueTime, operationType, status } = this.queryForm.params;
      const param = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          createStartTime: '',
          createEndTime: '',
          vehicleNumberList: [],
          status,
          operationType
        }
      };
      const inputVal = this.listVal.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
      const mdfeKeyList = this.mdfeKey.split(/\r?\n/).map(item => item.replace(/\s+/g, '')).filter(item => Boolean(item));
      if (inputVal.length > 10) {
        this.$message.error(this.$t('mdfeTranslate.MostlyQuery10Plates'));
        return;
      }
      if (inputVal.length > 0) {
        param.params['vehicleNumberList'] = inputVal;
      }
      if (mdfeKeyList.length > 2000) {
        this.$message.error(this.$t('mdfeTranslate.SingleMostQuery2000MDFEKey'));
        return;
      }
      if (mdfeKeyList.length > 0) {
        param.params['mdfeKeyList'] = mdfeKeyList;
      }
      if (Array.isArray(invoiceIssueTime) && invoiceIssueTime.length === 2) {
        param.params.createStartTime = invoiceIssueTime[0];
        param.params.createEndTime = invoiceIssueTime[1];
      } else {
        param.params.createStartTime = '';
        param.params.createEndTime = '';
        if (mdfeKeyList.length === 0) {
          this.$message.error(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      getMdfeOperationLog(param).then(res => {
        res.data.records.map(item => {
          if (item.transportInfo) {
            item.transportInfo = JSON.parse(item.transportInfo);
          }
          if (item.updateUser) {
            item.createUserStr = this.userObj[item.updateUser] || '';
          }
          if (item.originRequestParam) {
            item.originRequestParam = JSON.stringify(JSON.parse(item.originRequestParam), null, 2);
          }
          if (item.responseData) {
            item.responseData = JSON.stringify(JSON.parse(item.responseData), null, 2);
          }
        });
        this.tableData = res.data.records;
        this.total = res.data.total;
        console.log(this.tableData, '===this.tableData');
      });
    },
    // 重置
    onReset() {
      this.queryForm.params.status = null;
      this.queryForm.params.operationType = null;
      this.queryForm.params.invoiceIssueTime = [startTime, endTime];
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = 10;
      this.listVal = '';
      this.mdfeKey = '';
      this.getTable();
    },
    // 翻页
    getCurrentTable(val) {
      this.queryForm.pageNumber = val;
      this.getTable();
    },
    // 改变每页显示数量
    getSizeTable(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTable();
    }
  }
};
</script>
<style scoped>
.paramsStyle {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
